import React, { useState } from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import PerfectoHome from './components/PerfectoHome';
import { CartProvider } from './components/CartContext';
import FloatingCartButton from './components/FloatingCartButton';
import CartModal from './components/CartModal';

function App() {
  const [cartModalOpen, setCartModalOpen] = useState(false);

  return (
    <CartProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PerfectoHome />} />
          </Routes>
          
          {/* Floating Cart Button - visible across all pages */}
          <FloatingCartButton onCartOpen={() => setCartModalOpen(true)} />
          
          {/* Global Cart Modal */}
          <CartModal 
            isOpen={cartModalOpen} 
            onClose={() => setCartModalOpen(false)} 
          />
        </BrowserRouter>
      </div>
    </CartProvider>
  );
}

export default App;
